module.exports = __webpack_public_path__ + "img/poster.452993fa.jpg";